module.exports = __webpack_public_path__ + "img/q2a3.6c4eddbf.png";